import { FC } from "react"
import { LeadworkflowDetails } from "../../../../../../types"
import LeadworkflowBehaviour from "./sections/behaviour"
import LeadworkflowDisclaimers from "./sections/disclaimers"
import LeadworkflowSteps from "./sections/steps"
import { syncTxtMsgsDisclaimer } from "./utils"

export { syncTxtMsgsDisclaimer } from "./utils"

interface Props {
  values: LeadworkflowDetails
  tab: string
  setFormField: (name: string, value: any) => void
}

const ManageLeadworkflowFormContent: FC<Props> = ({
  values,
  tab,
  setFormField
}) => {
  const setConfigField = (field: string, value: any) => {
    const next = { ...values.config_json, [field]: value }
    setFormField("config_json", syncTxtMsgsDisclaimer(next))
  }

  const removeConfigField = (field: string) => {
    const { [field]: _, ...rest } = values.config_json
    setFormField(
      "config_json",
      syncTxtMsgsDisclaimer(rest as typeof values.config_json)
    )
  }

  return (
    <>
      {tab === "behaviour" && (
        <LeadworkflowBehaviour
          values={values}
          setConfigField={setConfigField}
          removeConfigField={removeConfigField}
        />
      )}
      {tab === "disclaimers" && (
        <LeadworkflowDisclaimers
          values={values}
          setConfigField={setConfigField}
        />
      )}
      {tab === "steps" && (
        <LeadworkflowSteps values={values} setConfigField={setConfigField} />
      )}
    </>
  )
}

export default ManageLeadworkflowFormContent
